import {createAsyncThunk} from "@reduxjs/toolkit";
import {AxiosResponse} from "axios";
import instance from "@/config/axios";
import { serializeQueryParam } from '@/utils';

export const getUserList = createAsyncThunk('user/getUserList',
  async ({role, search, page, sort, size}: UserListQuery) => {
    const url = `v1/users${serializeQueryParam({
      roleId: role,
      search,
      page,
      sortBy: sort,
      size
    })}`
    const response: AxiosResponse<UserState> = await instance.get(url)
    return response.data
  })

export const createUser = createAsyncThunk('user/createUser',
  async (data: UserPayload) => {
    const response: AxiosResponse<UserState> = await instance.post('v1/users', data)
    return response.data
  })

export const editUser = createAsyncThunk('user/editUser',
  async ({ id, data }: any) => {
    const response: AxiosResponse<UserState> = await instance.put(`v1/users/${id}`, data)
    return response.data
  })
